module.exports = __webpack_public_path__ + "img/madara.e8faa63a.jpg";